import classNames from "classnames";
import { useState, useRef } from "react";
import { ChevronDownIcon } from "../AscIcons";
import styles from "./AscAccordion.module.scss";
import { AccordionPropsI } from "./AscAccordion.type";
import AscRichTextViewer from "../AscRichTextEditor/AscRichTextViewer/AscRichTextViewer";

function AscAccordion({
  sections = [],
  singleOpen = false,
  className,
  contentClassName,
  contentWrapperClassName,
  titleClassName,
  activeClassName,
}: AccordionPropsI) {
  const [activeSectionIndex, setActiveSectionIndex] = useState<number | null>(
    null
  );
  const [activeSectionIndexes, setActiveSectionIndexes] = useState<number[]>(
    []
  );
  const contentRefs = useRef<(HTMLDivElement | null)[]>([]);

  const handleClick = (index: number) => {
    if (singleOpen) {
      setActiveSectionIndex(index === activeSectionIndex ? null : index);
    } else {
      setActiveSectionIndexes(
        activeSectionIndexes.includes(index)
          ? activeSectionIndexes.filter((i) => i !== index)
          : [...activeSectionIndexes, index]
      );
    }
  };

  const isOpen = (index: number) => {
    return singleOpen
      ? index === activeSectionIndex
      : activeSectionIndexes.includes(index);
  };

  return (
    <div className={styles.accordionList}>
      {sections &&
        sections.length > 0 &&
        sections.map((section, index) => (
          <div
            key={index}
            className={classNames(
              styles.accordion,
              {
                [classNames(styles.active, activeClassName)]: isOpen(index),
              },
              className
            )}
          >
            <div
              className={classNames(styles.accordionTitle, titleClassName)}
              onClick={() => handleClick(index)}
              data-testid={"section-title"}
            >
              <h3>{section.title}</h3>
              <div className={styles.accordionArrow}>
                <ChevronDownIcon />
              </div>
            </div>
            <div
              className={classNames(styles.accordionContent, contentClassName)}
              ref={(ref) => (contentRefs.current[index] = ref)}
              style={{
                maxHeight: isOpen(index)
                  ? `${contentRefs.current[index]?.scrollHeight}px`
                  : 0,
                opacity: isOpen(index) ? 1 : 0,
              }}
            >
              <div
                className={classNames(
                  styles.accordionContentWrapper,
                  contentWrapperClassName
                )}
              >
                {section?.description && (
                  <AscRichTextViewer
                    className={styles.accordionContentWrapper}
                    inferValue={section?.description}
                  />
                )}
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}

export default AscAccordion;
